module.exports = __webpack_public_path__ + "img/e654bdc.png";